// extracted by mini-css-extract-plugin
export var ticketsWindow = "tickets-popup-modules--ticketsWindow--1gKNq";
export var isOpen = "tickets-popup-modules--isOpen--2Z7cg";
export var ticketsWindowInner = "tickets-popup-modules--ticketsWindowInner--3jS4v";